import { generateSpanWithDataTestId } from '@app/shared/utils';

import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const scheduleModeOptions: {
  label: string | JSX.Element;
  value: NWorkSchedule.ScheduleMode;
}[] = [
  {
    label: generateSpanWithDataTestId('изменить график', 'work-schedule-edit'),
    value: 'edit',
  },
  {
    label: generateSpanWithDataTestId('удалить график', 'work-schedule-delete'),
    value: 'delete',
  },
];
